function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_469",
  d: "M38.2,16.4c-9,0-16.3,7.3-16.4,16.4c0,9,7.3,16.3,16.4,16.4c9,0,16.3-7.3,16.4-16.4 C54.5,23.7,47.2,16.4,38.2,16.4z M38.2,21.8c6,0,10.9,4.8,10.9,10.8c0,0,0,0.1,0,0.1c0,6-4.8,10.9-10.8,10.9c0,0-0.1,0-0.1,0 c-6,0-10.9-4.8-10.9-10.8c0,0,0-0.1,0-0.1C27.2,26.7,32.1,21.8,38.2,21.8C38.1,21.8,38.2,21.8,38.2,21.8z M69.1,26.4 c-6.5,0-11.8,5.3-11.8,11.8c0,6.5,5.3,11.8,11.8,11.8c6.5,0,11.8-5.3,11.8-11.8C80.9,31.7,75.6,26.4,69.1,26.4L69.1,26.4z  M69.1,31.8c3.5,0,6.3,2.8,6.4,6.2c0,0,0,0.1,0,0.1c0,3.5-2.8,6.3-6.3,6.3c0,0-0.1,0-0.1,0c-3.5,0-6.3-2.8-6.4-6.2c0,0,0-0.1,0-0.1 c0-3.5,2.8-6.3,6.3-6.3C69,31.8,69.1,31.8,69.1,31.8L69.1,31.8z M37.3,50.9C22,51.3,9.9,63.8,10,79v0.1c0,0.7,0,1.4,0,1.9 c0.1,1.4,1.3,2.6,2.7,2.6h50.9c1.4,0,2.6-1.2,2.7-2.6c0-0.7,0-1.3,0-2c0-1.2-0.1-2.4-0.2-3.6h21.1c1.4,0,2.6-1.2,2.7-2.6 c0-0.7,0-1.4,0-2c-0.2-10.7-9-19.3-19.8-19.1c-0.1,0-0.2,0-0.2,0h-1.8c-4.7,0-9.3,1.6-12.9,4.6c-4.6-3.6-10.3-5.5-16.2-5.5 L37.3,50.9z M37.3,56.4h1.8c5.2,0,10.3,2,14.1,5.5c0.1,0.1,0.3,0.3,0.5,0.5c4.4,4.2,6.9,9.9,7.1,15.9H15.5 C15.8,66.3,25.4,56.7,37.3,56.4L37.3,56.4z M68.2,57.3H70c7.5-0.4,13.9,5.3,14.5,12.7H64.9c-1.2-3.6-3.1-6.9-5.6-9.8 C61.8,58.3,65,57.3,68.2,57.3L68.2,57.3z"
});

var SvgIUsers = function SvgIUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_users.a3b9c50e.svg";
export { ForwardRef as ReactComponent };